import * as React from 'react';
export const Select = ({
  register,
  name,
  options,
  defaultValue,
  ...rest
}: any) => {
  return (
    <select defaultValue={defaultValue} {...register(name)} {...rest}>
      {options.map((option: string, index: string) => (
        <option value={option} key={index}>
          {option}
        </option>
      ))}
    </select>
  );
};
